import React from "react";

// Simple redirect-based approach (most reliable)
const HitPaySimpleCheckout = ({ checkoutUrl, buttonText = "Confirm Payment" }) => {
  const handlePayment = () => {
    if (checkoutUrl) {
      // Direct redirect to HitPay checkout page
      window.location.href = checkoutUrl;
    } else {
      console.error("No checkout URL provided");
    }
  };

  return (
    <div className="text-end mt-3 w-100">

    <button 
      onClick={handlePayment}
      className="btn btn-outline-success "
      >
      {buttonText}
      
    </button>
      </div>
  );
};

export default HitPaySimpleCheckout;